/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-11-06 15:18:41
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-06-03 14:48:33
 */
import { JSEncrypt } from 'jsencrypt'
import request from '@/utils/request'
import type * as CommonType from '@/typings/common'
import type * as SystemType from '@/typings/system'
import type { CommonRes } from '@/typings/common'
import type { ISystemAccount } from '@/typings/system'
import type { IAccountInfoType } from '@/typings/system'
import type { PagedResponse } from '@/typings/common'

// 删除角色
export async function deleteAccount(params: CommonType.IdParams) {
  return request('/api/v2/system/account_delete', {
    method: 'post',
    data: params
  })
}

interface IAccountListRequest extends CommonType.IPageSize {
  role_code?: string
  key?: string
  // 状态 1：正常，2：删除，3：冻结
  status?: number
  is_hide_option?: number
}
// 获取所有账号列表
export async function getAccountlist(params: IAccountListRequest) {
  return request<CommonRes<PagedResponse<IAccountInfoType>>>('/api/v2/system/account_search', {
    method: 'get',
    data: params
  })
}

interface IFrozenAccountRequest {
  id: number
  status: number
  content: string
}
// 冻结、解冻系统账号
export async function frozenAccount(params: IFrozenAccountRequest) {
  return request('/api/v2/system/account_frozen', {
    method: 'post',
    data: params
  })
}

// 获取系统账号详情
export async function getAccountDetail(params: CommonType.IdParams) {
  return request('/api/v2/system/account_get', {
    method: 'get',
    data: params
  })
}

interface ISaveAccountRequest {
  account: SystemType.IAccountDetailType
}
// 新增/编辑角色
export async function saveAccount(params: ISaveAccountRequest) {
  const account = { ...params.account }
  if (account.password) {
    account.password = await encryptPassword(account.password)
  }
  return request('/api/v2/system/account_save', {
    method: 'post',
    data: {
      account,
      password_encrypted: true
    }
  })
}

// 团队职级列表
export async function getTeamJobList() {
  return request('/api/v2/system/rank_list', {
    method: 'GET',
    data: {}
  })
}

interface IFakeAccountLoginRequest {
  code?: string
  is_app?: boolean
  name?: string
  password?: string
}

let loginPublicKeyPEM = ''

async function getLoginPublicKeyPEM(): Promise<string> {
  if (loginPublicKeyPEM) {
    return loginPublicKeyPEM
  }
  const res = await request<CommonRes<{ public_key?: string }>>(
    '/api/v2/system/account_login_public_key',
    { method: 'GET' }
  )
  if (res?.code === 0 && res.data?.public_key) {
    loginPublicKeyPEM = res.data.public_key
    return loginPublicKeyPEM
  }
  throw new Error('获取登录公钥失败')
}

async function encryptPassword(password?: string): Promise<string> {
  if (!password) {
    throw new Error('请输入密码')
  }
  const pem = await getLoginPublicKeyPEM()
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(pem)
  const encrypted = encryptor.encryptOAEP(password)
  if (!encrypted) {
    throw new Error('密码加密失败')
  }
  return encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

// 用户登录
export async function fakeAccountLogin(params: IFakeAccountLoginRequest) {
  return request('/api/v2/system/account_login', {
    method: 'POST',
    data: {
      ...params,
      password: await encryptPassword(params.password),
      password_encrypted: true
    }
  })
}
interface IAddAccountMenuViewRequest {
  view: {
    id?: number
    menu_code: string
    relation_id: number
    relation_type?: string
    sort: string
  }
}
// 创建用户查看数据筛选状态
export async function addAccountMenuView(params: IAddAccountMenuViewRequest) {
  return request('/api/v2/system/account_menu_view_create', {
    method: 'post',
    data: params
  })
}

// 用户登出
export async function accountLogout() {
  return request('/api/v2/system/account_logout', {
    method: 'POST',
    data: {}
  })
}

interface ISendForgetCodeRequest {
  phone: string
}
// 忘记密码发送验证码
export async function sendForgetCode(params: ISendForgetCodeRequest) {
  return request('/api/v2/system/account_find_password_send_code', {
    method: 'GET',
    data: params
  })
}
interface IUpdateAccountMenuViewRequest {
  view: {
    id: number
    menu_code: string
    relation_id: number
    relation_type?: string
    sort: string
  }
}
// 更新用户查看数据筛选状态
export async function updateAccountMenuView(params: IUpdateAccountMenuViewRequest) {
  return request('/api/v2/system/account_menu_view_update', {
    method: 'post',
    data: params
  })
}

interface IretrievePasswordRequest {
  code?: string
  confirm_password?: string
  new_password?: string
  phone?: string
}
// 忘记登录找回密码
export async function retrievePassword(params: IretrievePasswordRequest) {
  return request('/api/v2/system/account_find_password', {
    method: 'POST',
    data: {
      ...params,
      new_password: await encryptPassword(params.new_password),
      confirm_password: await encryptPassword(params.confirm_password),
      password_encrypted: true
    }
  })
}
interface IDelAccountMenuViewRequest {
  id: number
}
// 删除用户查看数据筛选状态
export async function delAccountMenuView(params: IDelAccountMenuViewRequest) {
  return request('/api/v2/system/account_menu_view_delete', {
    method: 'post',
    data: params
  })
}

interface ISendLoginCodeRequest {
  name?: string
  password?: string
}
// 登录发送验证码
export async function sendLoginCode(params: ISendLoginCodeRequest) {
  return request('/api/v2/system/account_login_send_code', {
    method: 'GET',
    data: {
      ...params,
      password: await encryptPassword(params.password),
      password_encrypted: true
    }
  })
}
interface IGetAccountMenuViewRequest {
  menu_code: string
  relation_id: number
  relation_type?: string
}
// 获取用户查看数据筛选状态
export async function getAccountMenuView(params: IGetAccountMenuViewRequest) {
  return request('/api/v2/system/account_menu_view_get_current', {
    method: 'GET',
    data: params
  })
}

interface IGetWechatUserInfoRequest {
  code: string
  state: string
  is_app: string
}
// 获取微信用户信息
export async function get_wechat_user_info(params: IGetWechatUserInfoRequest) {
  return request('/api/v2/system/wechat_get_user_info', {
    method: 'GET',
    data: params
  })
}

interface IWechatSendBindCodeRequest {
  access_token?: string
  open_id?: string
  phone?: string
}
// 发送微信绑定验证码
export async function wechat_send_bind_code(params: IWechatSendBindCodeRequest) {
  return request('/api/v2/system/wechat_bind_send_code', {
    method: 'GET',
    data: params
  })
}

interface IBindWechatRequest {
  access_token?: string
  open_id?: string
  phone?: string
  sms_code?: string
}
// 绑定微信账号
export async function bind_wechat(params: IBindWechatRequest) {
  return request('/api/v2/system/wechat_bind', {
    method: 'GET',
    data: params
  })
}

// 获取用户信息
export async function getUserInfo(params: CommonType.IdParams) {
  return request('/api/v2/system/account_brief_info', {
    method: 'GET',
    data: params
  })
}

interface IUpdatePasswordRequest {
  confirm_password?: string
  new_password?: string
  old_password?: string
}
// 修改密码
export async function updatePassword(params: IUpdatePasswordRequest) {
  return request('/api/v2/system/account_change_password', {
    method: 'POST',
    data: {
      ...params,
      old_password: await encryptPassword(params.old_password),
      new_password: await encryptPassword(params.new_password),
      confirm_password: await encryptPassword(params.confirm_password),
      password_encrypted: true
    }
  })
}

interface IuploadAvatarRequest {
  avatar: string
}
// 上传头像
export async function uploadAvatar(params: IuploadAvatarRequest) {
  return request('/api/v2/system/account_upload_avatar', {
    method: 'POST',
    data: params
  })
}

interface IGetAccountListRequest {
  role_codes?: string[] // 包含删除的冻结的数据也会返回
  is_need_frozen?: number
  is_hide_option?: number // 是否需要选项隐藏
}
// 根据角色获取用户列表
export async function getAccountListByRole(params: IGetAccountListRequest) {
  return request<CommonRes<{ list: ISystemAccount[] }>>('/api/v2/system/user_list_by_role_codes', {
    method: 'GET',
    data: params
  })
}

interface IGetAccountListByRoleCodesRequest {
  role_codes?: string[] // 包含冻结的数据也会返回
  is_need_frozen?: number
  is_hide_option?: number // 是否需要选项隐藏
}
// 根据角色获取用户列表
export async function getAccountListByRoleCodes(params: IGetAccountListByRoleCodesRequest) {
  return request<CommonRes<{ list: ISystemAccount[] }>>(
    '/api/v2/system/account_list_by_role_codes',
    {
      method: 'GET',
      data: { ...params }
    }
  )
}

// 验证是否登录
export async function fetchLoginStatus() {
  return request('/api/v2/system/account_auth', {
    method: 'GET'
  })
}

// 获取微信State
export async function get_wechat_state() {
  return request('/api/v2/system/wechat_get_state', {
    method: 'GET'
  })
}
